import { render, staticRenderFns } from "./AccionEvento.vue?vue&type=template&id=243a391e&"
import script from "./AccionEvento.vue?vue&type=script&lang=js&"
export * from "./AccionEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports